import { GlobalStyles } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { LicenseInfo } from "@mui/x-license";
import React from "react";
import { ToastStyled } from "../../components/app/ToastStyled";
import { sbTheme } from "../../styles/sbDesignSystem/sbTheme";

// MUI X Pro license key
const MUI_LICENSE_KEY =
  "f649297e1a1680c88e9d9c544fae95a8Tz0xMjM3NTMsRT0xODAxMTgwNzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MixLVj0y";

LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);

interface Props {
  children: React.ReactNode;
}

export const ThemeShell: React.FC<Props> = ({ children }) => (
  <ThemeProvider theme={sbTheme} defaultMode="system">
    <ToastStyled />
    <CssBaseline />
    <GlobalStyles
      styles={(theme) => ({
        "::-webkit-scrollbar": {
          width: "4px",
        },
        "::-webkit-scrollbar-thumb": {
          borderRadius: "2px",
          background: theme.palette.surfaceLight50.main,
        },
      })}
    />
    {children}
  </ThemeProvider>
);
